<template>
  <div class="editor-prize-modal-content">
    <h2 v-if="showTitle && title" class="paragraph-bold">{{ title }}</h2>

    <PrizeTierTabs
      v-if="tabs.length > 0"
      class="mb-300"
      v-bind="{ addOns: config.addOns, licensedTerritory, lotteryId, tabs }"
    />

    <section v-if="content.length">
      <template v-for="item in content" :key="item?.sys.id">
        <h3 v-if="item.caption" class="headline-h4-headline mb-100">
          {{ item.caption }}
        </h3>

        <ContentfulRenderer class="content" :data="item.content" />
      </template>
    </section>
  </div>
</template>

<script lang="ts" setup>
import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'
import type { ContentBlock } from '#content/shared/@types/generated/cms/graphql-schema-types'

import type { Config } from '../@types/editor'

type Props = {
  config: Config
  lotteryId: LotteryId
  showTitle?: boolean
}

const { config, lotteryId, showTitle } = defineProps<Props>()

const licensedTerritory = useLicensedTerritory({ raw: true })

const { tabs } = useEditorPrizeTiers(() => config)

const { data } = useContent().getPrizes(lotteryId.toLowerCase(), { lazy: true })

const content = computed(() => (data.value?.contentBlocksCollection?.items as ContentBlock[]) || [])
const title = computed(() => data.value?.title)
</script>

<style lang="scss" scoped>
@use '#product/app/components/prize-content' as *;

.editor-prize-modal-content {
  @include prize-content;
}
</style>
